module.exports = __webpack_public_path__ + "static/img/rightbot.0b78f9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/rightbot.jpg
// module id = 6M+K
// module chunks = 49